import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { AuthUser, CreateUserRequest } from '@/openapi';
import { UsersService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useCreateNonPartnerUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: AuthUser) => {
      const requestBody: CreateUserRequest = {
        userType: user.role === 'hospital' ? 'hospital' : 'non-partner',
        displayName: user.displayName,
        email: user.email,
        partnerId: undefined,
      };
      const newUserResp = await UsersService.usersServiceCreateUser({
        body: requestBody,
      });

      if (!newUserResp?.data) {
        throw new Error('Failed to create new user');
      }

      const newUser = newUserResp.data;
      return UsersService.usersServiceSetUserRole({
        path: {
          id: newUser?.uid,
        },
        body: {
          role: user.role,
        },
      });
    },
    onSettled: async (_data, _error, _variables) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.users.list() }),
        _data?.data?.uid &&
          queryClient.invalidateQueries({
            queryKey: queryKeys.users.details(_data.data.uid),
          }),
      ]);
    },
  });
};
